import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { UserSessionService } from 'bna-angular-auth-client';
import { Subscription } from 'rxjs';
import { NotificationService } from 'src/app/core/services/firebase/notification.service';
import { EventService } from 'src/app/core/services/http/event.service';
import { JobSearchService } from 'src/app/core/services/http/maintenance/job-search.service';
import { LocalStorageService } from 'src/app/core/services/data/local-storage.service';
import { SHOWORGANIZATIONEMAILCOUNT } from 'src/app/shared/constants/local-storage-items.constants';
import { EmailNotificationCount } from '../../models/email-notification-count.model';
import { AssetService } from 'src/app/core/services/http/agency-mgmt/asset.service';
import { OrganizationSettingsResult } from 'src/app/shared/models/agency-mgmt/manager.service.model';
import { OrganizationService } from 'src/app/core/services/http/agency-mgmt/organization.service';
import { JobCacheService } from 'src/app/job/services/job-detail/job-cache.service';
import { ManagerService } from 'src/app/core/services/http/agency-mgmt/manager.service';
import { count } from 'console';
import { CommunicationsService } from 'src/app/core/services/data/communications.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  public sub: Subscription[] = [];
  private settingsUpdateSubscription!: Subscription;
  @Output() navigateToJobPost = new EventEmitter<void>();
  isOpenEmailDrawer: boolean = false;
  emailNotificationCount = 0;
  recommendationCount = 0;
  hideJobPostOnInspectionManager = false;
  pmUserIdList: EmailNotificationCount[] = null;
  organizationPmUserIds: string[] = null;
  isOpenRecommendationDrawer: boolean = false;
  orgSettings: OrganizationSettingsResult;
  public isAssetRecommendationEnabled: boolean;

  constructor(
    private firebaseSvc: NotificationService,
    private userSession: UserSessionService,
    private eventService: EventService,
    private jobSearchService: JobSearchService,
    private localStorageService: LocalStorageService,
    private UIContext: JobCacheService,
    private organizationService: OrganizationService,
    private assetService: AssetService,
    private communicationsService: CommunicationsService,
    private managerService: ManagerService
  ) {}

  ngOnInit(): void {
    this.userSession.isAuthenticated$.subscribe((auth) => {
      if (!auth.isAuthenticated) return;
    });
    this.getRecommendationsCount();
    this.eventService.hideJobPostOnInspectionManager$.subscribe({
      next: (value) => {
        this.hideJobPostOnInspectionManager = value ?? false;
      },
    });
    this.getSelectedTeam();
    this.subscribeToNofificationCountChange();
    this.getUnreadEmailCount();
    this.getRecommendationEnabledStatus();
    this.AssetRecommendationEnabled();

    this.firebaseSvc.emailCount$.subscribe((data) => {
      this.emailNotificationCount = data;
    });
  }

  AssetRecommendationEnabled() {
    if (this.settingsUpdateSubscription)
      this.settingsUpdateSubscription.unsubscribe();
    this.settingsUpdateSubscription =
      this.communicationsService.settingsUpdated$.subscribe(
        (isAssetRecommendationEnabled: boolean) => {
          this.isAssetRecommendationEnabled = isAssetRecommendationEnabled;
        }
      );
  }

  ngOnDestroy(): void {
    this.sub.forEach((sub) => sub.unsubscribe());
    if (this.settingsUpdateSubscription) {
      this.settingsUpdateSubscription.unsubscribe();
    }
  }

  getRecommendationEnabledStatus() {
    this.organizationService.getRecommendationEnabledStatus().subscribe({
      next: (res) => {
        this.isAssetRecommendationEnabled = res;
      },
    });
  }

  showEmailNotifications(): void {
    this.isOpenEmailDrawer = true;
    const bodyTag = document.body;
    bodyTag.classList.add('email-notification-open');
  }

  getEmailNotificationCount() {
    this.subscribeToNofificationCountChange();
    this.getUnreadEmailCount();
  }

  closeDrawer(): void {
    this.isOpenEmailDrawer = false;
    const bodyTag = document.body;
    bodyTag.classList.remove('email-notification-open');
  }

  getSelectedTeam() {
    this.jobSearchService.getSelectedTeam().subscribe({
      next: (res) => {
        if (res == null || res.length == 0) {
          return;
        }
        this.organizationPmUserIds = res.map((m) => m.userId);
        this.pmUserIdList = res.map((m) => ({
          userId: m.userId,
          emailCount: 0,
        }));
      },

      error: () => {},
    });
  }

  subscribeToNofificationCountChange() {
    this.sub.push(
      this.firebaseSvc.getEmailNotificationCount().subscribe(() => {
        this.getUnreadEmailCount();
      })
    );
  }

  getUnreadEmailCount() {
    this.sub.push(
      this.managerService.getUnreadEmailCount().subscribe({
        next: (count) => {
          this.firebaseSvc.setEmailCount(count);
        },
      })
    );
  }

  showRecommendations(): void {
    this.isOpenRecommendationDrawer = true;
  }

  closeRecommendationDrawer(): void {
    this.getRecommendationsCount();
    this.isOpenRecommendationDrawer = false;
  }

  getRecommendationsCount() {
    this.assetService.getRecommendationsCount().subscribe({
      next: (res) => {
        this.recommendationCount = res;
        console.log('res', res);
      },
    });
  }
}
